import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=a717adb4&scoped=true"
import script from "./VideoSection.vue?vue&type=script&lang=js"
export * from "./VideoSection.vue?vue&type=script&lang=js"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=a717adb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a717adb4",
  null
  
)

export default component.exports